import { Injectable } from '@angular/core';
var ConditionAction = /** @class */ (function () {
    function ConditionAction() {
    }
    ConditionAction.prototype.checkCondition = function (params, response, rec) {
        var result = 0;
        for (var i = 0; i < params.condition.length; i++) {
            var cond = params.condition[i];
            if (!cond.key && !cond.operator) {
                continue;
            }
            var value = void 0;
            if (cond.key.match(/^\$/)) {
                value = jsonpath.value(response, cond.key);
                if (typeof value === 'undefined') {
                    value = jsonpath.value(rec, cond.key);
                }
            }
            else {
                value = response[cond.key];
                if (typeof value === 'undefined') {
                    value = rec[cond.key];
                }
            }
            var re = this.checkOperator(cond.operator, value, cond.value) ? 1 : 0;
            if (i === 0) {
                result = re;
            }
            else {
                result = this.checkAndOr(cond.andor, result, re);
            }
        }
        return result ? 'true' : 'false';
    };
    ConditionAction.prototype.checkOperator = function (operator, operand1, operand2) {
        switch (operator) {
            case 'eq':
                return operand1 == operand2;
            case 'ne':
                return operand1 != operand2;
            case 'gt':
                return operand1 > operand2;
            case 'ge':
                return operand1 >= operand2;
            case 'lt':
                return operand1 < operand2;
            case 'le':
                return operand1 <= operand2;
            case 'isNull':
                return operand1 == null;
            case 'isNotNull':
                return operand1 != null;
            case 'match':
                if (typeof operand1 === 'undefined' || operand1 === null || operand1 === '') {
                    return false;
                }
                var str = String(operand1);
                var re = new RegExp(operand2);
                return (str.match(re) ? true : false);
            default:
                return operand1 == operand2;
        }
    };
    ConditionAction.prototype.checkAndOr = function (operator, operand1, operand2) {
        switch (operator) {
            case 'and':
                return operand1 & operand2;
            case 'or':
                return operand1 | operand2;
            default:
                return operand1 & operand2;
        }
    };
    ConditionAction.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    ConditionAction.ctorParameters = function () { return []; };
    return ConditionAction;
}());
export { ConditionAction };
var Condition = /** @class */ (function () {
    function Condition() {
    }
    return Condition;
}());
//# sourceMappingURL=condition.action.js.map